import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsModalComponent } from "../components/index";
import { SpsModalOpenDirective } from "../directives/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsModalComponent,
        SpsModalOpenDirective,
    ],
    exports: [
        SpsModalComponent,
        SpsModalOpenDirective,
    ]
})
export class SpsModalModule {}
